import {
	SET_ADDON_EMAIL,
	SET_GREEN_CHANNELS,
	SET_RECHARGE_FOR_SHIPMENT,
	SET_REPLAY_REQUEST,
	SET_SHIPMENT_EDIT_STATUS,
	SET_SHIPMENT_LIST,
} from "../../actions/shipment";

const ACTION_HANDLERS = {
	[SET_SHIPMENT_LIST]: (state, action) => ({
		...state,
		shipmentList: action.payload,
	}),
	[SET_SHIPMENT_EDIT_STATUS]: (state, action) => ({
		...state,
		shipmentEditStatus: action.payload.status,
		isEditingOrderStatus: action.payload.isEditingOrder,
		shipmentEditData: action.payload.data,
		orderErrors: action.payload.errors || undefined,
		highlightErrors: action.payload.highlightErrors || false,
	}),
	[SET_RECHARGE_FOR_SHIPMENT]: (state, action) => ({
		...state,
		rechargeDetails: {
			...state.rechargeDetails,
			...action.payload,
		},
	}),
	[SET_REPLAY_REQUEST]: (state, action) => ({
		...state,
		replayRequest: action.payload,
	}),
	[SET_ADDON_EMAIL]: (state, action) => ({
		...state,
		add_on_emails: action.payload,
	}),
	[SET_GREEN_CHANNELS]: (state, action) => ({
		...state,
		greenChannels: action.payload,
	}),
};
// ------------------------------------
// Reducer
// ------------------------------------
const initialState = { add_on_emails: [] };

export default function shipmentReducer(state = initialState, action) {
	const handler = ACTION_HANDLERS[action.type];
	return handler ? handler(state, action) : state;
}
